import { render, staticRenderFns } from "./stays.vue?vue&type=template&id=62e60004"
import script from "./stays.ts?vue&type=script&lang=ts&external"
export * from "./stays.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports